import { zIdName } from "src/types/ZIdName";
import { z } from "zod";
import { zUid } from "src/types/zUid";
import { SchedRowType } from "../../SchedulingTypes";

export const zCheckBulkPlanCreation = z.object({
  canCreate: z.boolean(),
  entityWithTasks: zIdName.array(),
});
export type ZCheckBulkPlanCreation = z.infer<typeof zCheckBulkPlanCreation>;

export const zBulkPlanCreation = z.object({
  newStartDate: z.string().optional(),
  templateEntityType: z.nativeEnum(SchedRowType),
  templateEntityId: zUid,
  entityIds: zUid.array(),
  changeStartDate: z.boolean(),
});
export type ZBulkPlanCreation = z.infer<typeof zBulkPlanCreation>;
